import React from "react";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { useBnbSelector } from "../../../redux/store";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import useGetBuildSpinnerFrame from "../../../hooks/shared/spin/useGetBuildSpinnerFrame";
import { generateImageSet } from "../../../utils/typedUtils";
import { BnbLabel } from "../../../utils/labels";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_EXIT_PASSIVE_SUMMARY } from "../../../utils/modalConstants";
import * as Styles from "./styles/MiniCarHero";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Text from "../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import ButtonWithIcon from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import { trackChangeModel } from "../../../utils/tracking";
import { isPassiveSummary } from "../../../utils/settings/bnbSettingUtils";
import AvailabilityBadges from "../../../../../../common-deprecated/components/aem/lexus/availability-badges/AvailabilityBadges";
import useStepUrl from "../../../hooks/shared/actions/useStepUrl";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

export type MiniCarHeroPropsType = {
    showChangeLink?: boolean;
};

const MiniCarHero = (props: MiniCarHeroPropsType): JSX.Element => {
    const { showChangeLink } = props;
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const car = useBnbSelector((state) => state.car);
    const { colour } = useBnbSelector((state) => state.basket);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const step = useBnbSelector((state) => state.navigation.step);

    const { getImage } = useGetBuildSpinnerFrame(false);
    const getFrame = (width: number, height: number): string =>
        getImage(width, height, 3, { bgColour: "", padding: 15 });
    const image = generateImageSet(getFrame, 1170, 480);

    const passiveSummary = isPassiveSummary(commonSettings);

    const modelStep = useStepUrl(NavStep.Model, undefined, undefined, () => trackChangeModel(step));

    return (
        <Styles.Wrapper>
            <Styles.Heading width={{ _: 1, md: 3 / 12 }} mb={{ _: 4, md: 0 }}>
                <Styles.Title>{car.grade.webtitleSectionName}</Styles.Title>
                {car.body.webtitleSectionName && <Styles.SubTitle>{car.body.webtitleSectionName}</Styles.SubTitle>}

                <AvailabilityBadges
                    isSoldOut={car.soldOut}
                    isAvailableForOnlineSales={car.availableForOnlineSales}
                    isAvailableForOnlineLeasing={car.availableForOnlineLeasing}
                />

                <Styles.Actions>
                    {showChangeLink && (
                        <ButtonWithIcon href={modelStep.href} onClick={modelStep.onClick}>
                            <Text.IconButton>
                                <BnbLabel label="changeGrade" />
                            </Text.IconButton>
                            <Icon variant="trade" />
                        </ButtonWithIcon>
                    )}

                    {passiveSummary && step === NavStep.Summary && (
                        <ButtonWithIcon
                            onClick={() => {
                                dispatch(
                                    showModal({
                                        type: MODAL_EXIT_PASSIVE_SUMMARY,
                                    }),
                                );
                            }}
                        >
                            <Text.IconButton>
                                <BnbLabel label="passiveSummaryEditConfiguration" />
                            </Text.IconButton>
                            <Icon variant="trade" />
                        </ButtonWithIcon>
                    )}
                </Styles.Actions>
            </Styles.Heading>

            <Styles.HeroImageWrapper width={{ _: 1, md: 7 / 12 }}>
                <Styles.HeroImage
                    src={image.src}
                    srcSet={image.srcset}
                    sizes=""
                    draggable={false}
                    alt={`${car.model.name} ${car.grade.name} ${colour.name}`}
                />
            </Styles.HeroImageWrapper>
        </Styles.Wrapper>
    );
};

export default MiniCarHero;
